/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li2_DescInputs */

const tr_iade_iptal_s9_li2_desc = /** @type {(inputs: Iade_Iptal_S9_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adresine kayıtlı e-postanızdan fesih talebini iletmek.`)
};

const en_iade_iptal_s9_li2_desc = /** @type {(inputs: Iade_Iptal_S9_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`send the termination request to this address from your registered email address.`)
};

const de_iade_iptal_s9_li2_desc = /** @type {(inputs: Iade_Iptal_S9_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden Sie die Beendigungsanfrage von Ihrer hinterlegten E-Mail-Adresse an diese Adresse.`)
};

const ru_iade_iptal_s9_li2_desc = /** @type {(inputs: Iade_Iptal_S9_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`направьте запрос о расторжении на этот адрес со своего зарегистрированного адреса электронной почты.`)
};

/**
* | output |
* | --- |
* | "send the termination request to this address from your registered email address." |
*
* @param {Iade_Iptal_S9_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li2_desc = /** @type {((inputs?: Iade_Iptal_S9_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s9_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li2_desc(inputs)
	return tr_iade_iptal_s9_li2_desc(inputs)
});